'use strict';

export var adminService = function(configService, $http) {

    var getFlyInUrl = function(ticketId, file) {
        return configService.getAppSettings().then(settings => {

            var url = `${settings.apiUrl}admin/flyinUrl`;

            return $http({
                url: url,
                method: 'GET',
                headers: {
                    'TicketId': ticketId
                }
            }).then(res => {
                return res.data + file;
            });
        });
    };

    return {
        getFlyInUrl: getFlyInUrl
    };
}

adminService.$inject = ['configService', '$http'];